/**
 * Индикатор загрузки с анимацией вращения, поддерживает разные размеры
 */
import { Loader2 } from 'lucide-react';
import { cn } from '@/utils/cn';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  testId?: string;
}

const sizes = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};

export function Spinner({ size = 'md', className, testId }: SpinnerProps) {
  return (
    <Loader2
      data-testid={testId}
      className={cn('animate-spin text-primary-600', sizes[size], className)}
    />
  );
}

